import React from "react";
import {useTranslate} from "../../system/useTranslate";
import RibbonButton from "./ribbon-button";

function splitRows(items, columns) {
    const rows = [];
    for (let index = 0; index < items.length; index += columns) {
        rows.push(items.slice(index, index + columns));
    }
    return rows;
}

function RibbonGroup({group, onCommand, active}) {
    const translate = useTranslate();

    const renderItem = (item) => (
        <RibbonButton
            key={item.title}
            item={item}
            active={item.activeKey ? Boolean(active[item.activeKey]) : false}
            onClick={() => onCommand(item)}
        />
    );

    const rows = group.grid ? splitRows(group.items, group.grid.columns) : [group.items];

    const itemsArea = (
        <div className="flex flex-column gap-1">
            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className="flex align-items-center justify-content-center gap-1">
                    {row.map(renderItem)}
                </div>
            ))}
        </div>
    );

    return (
        <div className="flex flex-column align-items-center justify-content-between border-1 border-200 border-round p-1 flex-none surface-0">
            <div className="flex-grow-1 flex align-items-center justify-content-center p-1">{itemsArea}</div>
            <span className="text-xs text-gray-400">{translate(group.title)}</span>
        </div>
    );
}

export default RibbonGroup;